import { Column, Row } from 'Components/Grid';
import { CardStyled, RowExhibition, SubTitleModalDetail, TitleModalDetail } from '../styles';

export const CookiesDetail = ({ name, cookies }) => {
  const convertExpires = expires => {
    if (expires === -1) {
      return 'Session';
    } else if (Number((expires / 1000).toFixed(0)) < 60) {
      return `${Number((expires / 1000).toFixed(0))} Segundo(s)`;
    } else if (Number((expires / 60000).toFixed(0)) < 60) {
      return `${Number((expires / 60000).toFixed(0))} Minuto(s)`;
    } else if (Number((expires / 3600000).toFixed(0)) < 24) {
      return `${Number((expires / 3600000).toFixed(0))} Hora(s)`;
    } else {
      const days = Number((expires / 3600000).toFixed(0)) / 24;
      return `${days.toFixed(0)} Dia(s)`;
    }
  };
  return (
    <>
      <Row className="mb-3">
        <Column xs={1} flex className="justify-content-center align-items-start px-0">
          <div
            className="swal2-icon swal2-info swal2-icon-show"
            style={{
              display: 'flex',
              height: '1.5rem',
              width: '1.5rem',
              margin: '0',
            }}
          >
            <div className="swal2-icon-content" style={{ fontSize: '1.5rem' }}>
              i
            </div>
          </div>
        </Column>
        <Column>
          <TitleModalDetail>Detalhes da tag {name}</TitleModalDetail>
          <SubTitleModalDetail>Listagem dos cookies que foram encontrados dentro da tag</SubTitleModalDetail>
        </Column>
      </Row>
      <div
        style={{
          height: '165px',
          overflowY: 'auto',
        }}
      >
        {cookies.map((cookie, index) => (
          <CardStyled className="mb-2" key={index}>
            <RowExhibition>
              <Column className="font-weight-bold" xs={4}>
                Nome:
              </Column>
              <Column>{cookie?.name}</Column>
            </RowExhibition>
            <RowExhibition>
              <Column className="font-weight-bold" xs={4}>
                Expiração:
              </Column>
              <Column>{convertExpires(cookie?.expires)}</Column>
            </RowExhibition>
            <RowExhibition>
              <Column className="font-weight-bold" xs={4}>
                Região:
              </Column>
              <Column>{cookie?.region}</Column>
            </RowExhibition>
            <RowExhibition>
              <Column className="font-weight-bold" xs={4}>
                Bloqueado:
              </Column>
              <Column>{cookie?.auto_block ? 'Bloqueado' : 'Não bloqueado'}</Column>
            </RowExhibition>
          </CardStyled>
        ))}
      </div>
    </>
  );
};
